import React, { useState, useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
	Alert,
} from 'reactstrap';


import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { setRequireCloseModal } from '../../../slices/personalProtectiveEquipment/reducer';
import { getPersonalProtectiveEquipmentList, releaseWarehouseItem, setPersonalProtectiveEquipmentCancelled } from '../../../slices/thunks';

const DeletePersonalProtectiveEquipmentModal = ({ dataPersonalProtectiveEquipment, isOpen, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorSensor = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const { isLoadingList, requireCloseModal } = useSelector(selectorSensor);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleModal();
			}
		}
	}, [requireCloseModal]);

	async function handlerDelete() {
		try {
			await dispatch(setPersonalProtectiveEquipmentCancelled(dataPersonalProtectiveEquipment._id));
			for (const item of dataPersonalProtectiveEquipment.assigned_items) {
				await dispatch(releaseWarehouseItem(item));
			}
			await dispatch(getPersonalProtectiveEquipmentList());
			dispatch(setRequireCloseModal(false));
			handlerToggleModal();
		} catch (error) {
			console.error("Error al cancelar el equipo de protección personal:", error);
		}
	}


	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de cancelar la asignación de Equipamiento de Protección Personal!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Equipamiento de Protección Personal: {dataPersonalProtectiveEquipment !== null ? dataPersonalProtectiveEquipment.code : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button className='btn-danger btn-label' onClick={() => handlerToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
							<button className='btn btn-label btn-primary' onClick={() => handlerDelete()} disabled={isLoadingList}>{isLoadingList ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeletePersonalProtectiveEquipmentModal;
